import { TFunction } from 'i18next';

export enum Explicit {
    'true' = 'Yes',
    'false' = 'No'
}

export const mapExplicit = (explicit: boolean | undefined, t: TFunction) => {
    const explicitData = {
        current: t(`yourLocalContent.yourTitles.dropdowns.explicit.${explicit}`, {
            defaultValue: t('yourLocalContent.yourTitles.select')
        }),
        currentKey: explicit,
        all: {
            true: t('yourLocalContent.yourTitles.dropdowns.explicit.true'),
            false: t('yourLocalContent.yourTitles.dropdowns.explicit.false')
        }
    };

    return { explicitData };
};
